module.exports = __webpack_public_path__ + "static/media/file-broken.0eff64c9.png";